import { Account } from './account.model';
/**Usuario de la aplicación */
export class AppUser {
    public id: string;
    public emailAddress: string;
    public fullName: string;
}